/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, RoutePath } from "../../utility/Constant";

const ProjectsUniquePage = () => {
  const { projectsApi } = apiPath;
  const [uniqueData, uniqueLoading] = useFetch(projectsApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setFilteredData(uniqueData?.filter((item) => item._id === id)[0]);
  }, [uniqueData, id]);

  if (uniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const {
    project_title,
    short_description,
    project_description,
    image_link,
    client_name,
    country,
    status,
    project_time,

    _id,
    company_name,

  } = filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "Name",
      type: "Text",
      name: "project_title",
      defaultValue: project_title,
      required: false,
    },
    // #2
    {
      elementType: "input",
      label: "Company Name",
      type: "Text",
      name: "company_name",
      defaultValue: company_name,
      required: false,
    },
    // #3
    {
      elementType: "input",
      label: "Client Name",
      type: "Text",
      name: "client_name",
      defaultValue: client_name,
      required: false,
    },
    // #4
    {
      elementType: "input",
      label: "Country Name",
      type: "Text",
      name: "country",
      defaultValue: country,
      required: false,
    },
    // #5
    {
      elementType: "input",
      label: "Project Time",
      type: "Text",
      name: "project_time",
      defaultValue: project_time,
      required: false,
    },
    {
      elementType: "select",
      label: "Status",
      type: "select",
      name: "status",
      options: ["ongoing", "completed",],
      defaultValue: status,
      required: false,
    },
    // {
    //   elementType: "textField",
    //   label: "short description",
    //   type: "Text",
    //   name: "short_description",
    //   defaultValue: short_description,
    //   required: false,
    // },
    {
      elementType: "textField",
      label: "project description",
      type: "Text",
      name: "project_description",
      defaultValue: project_description,
      required: false,
    },
    {
      elementType: "file",
      label: `banner Image`,
      name: "image_link",
      type: "file",
      fullCol: true,
      defaultValue: image_link,
      required: false,
    },
  ];

  const update = (data) => {
    const { image_link, ...rest } = data;
    rest.image_link = {
      url: image_link,
    };
    updateData(projectsApi, rest, _id);
    setTimeout(() => {

      window.location.href = "/" + RoutePath.projectsContent;
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ProjectsUniquePage;
